import { ComponentFactoryResolver, Injector, NgZone, Type, ElementRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Overlay } from '@angular/cdk/overlay';
import { filter } from 'rxjs/operators';
import { ContextMenuRef } from './context-menu-ref';
import { CONTEXT_MENU_DATA } from './context-menu-data';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/cdk/overlay";
var ORIGIN_ID = 'dynamic-context-menu-origin';
var ContextMenu = /** @class */ (function () {
    function ContextMenu(router, zone, injector, resolver, overlay) {
        var _this = this;
        this.router = router;
        this.zone = zone;
        this.injector = injector;
        this.resolver = resolver;
        this.overlay = overlay;
        this.router.events
            .pipe(filter(function (e) { return e instanceof NavigationStart; }))
            .subscribe(function () { return _this.close(); });
    }
    /**
     * Show specified modal.
     */
    ContextMenu.prototype.open = function (component, e, params) {
        if (params === void 0) { params = {}; }
        this.close();
        var overlayRef = this.createOverlay(e, params);
        this.openContextMenu = new ContextMenuRef(overlayRef);
        var injector = new PortalInjector(this.injector, new WeakMap([
            [CONTEXT_MENU_DATA, params.data],
            [ContextMenuRef, this.openContextMenu],
        ]));
        var portal = new ComponentPortal(component, null, injector);
        overlayRef.attach(portal);
        this.bindEventsToOverlay();
        return this.openContextMenu;
    };
    /**
     * Close currently open context menu.
     */
    ContextMenu.prototype.close = function () {
        this.removeLastOrigin();
        if (this.openContextMenu) {
            this.openContextMenu.close();
            this.openContextMenu = null;
        }
    };
    ContextMenu.prototype.createOverlay = function (e, params) {
        return this.overlay.create({
            positionStrategy: this.getMenuPositionStrategy(e, params),
            scrollStrategy: this.overlay.scrollStrategies.close(),
            hasBackdrop: true,
            backdropClass: 'context-menu-backdrop',
            panelClass: 'context-menu-overlay'
        });
    };
    ContextMenu.prototype.bindEventsToOverlay = function () {
        var _this = this;
        this.openContextMenu.contextMenuElement().addEventListener('click', function () {
            _this.close();
        });
        this.openContextMenu.backdropClick().subscribe(function () {
            _this.close();
        });
        this.openContextMenu.backdropElement().addEventListener('contextmenu', function (e) {
            e.preventDefault();
            _this.close();
        });
        this.openContextMenu.detachments().subscribe(function () {
            _this.close();
        });
    };
    ContextMenu.prototype.getMenuPositionStrategy = function (e, params) {
        this.createOriginFromEvent(e, params);
        var primary = {
            originX: params.originX || 'center',
            originY: params.originY || 'bottom',
            overlayX: params.overlayX || 'center',
            overlayY: params.overlayY || 'top',
        };
        return this.overlay.position().flexibleConnectedTo(new ElementRef(this.lastOrigin))
            .withPositions([
            primary,
            { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom' },
            { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
            { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'bottom' }
        ]);
    };
    ContextMenu.prototype.createOriginFromEvent = function (e, params) {
        this.removeLastOrigin();
        if (e instanceof HTMLElement || e instanceof EventTarget) {
            this.lastOrigin = e;
        }
        else {
            this.lastOrigin = document.createElement('div');
            this.lastOrigin.style.position = 'fixed';
            this.lastOrigin.style.top = e.clientY + (params.offsetY || 0) + 'px';
            this.lastOrigin.style.left = e.clientX + (params.offsetX || 0) + 'px';
            this.lastOrigin.id = ORIGIN_ID;
            document.body.appendChild(this.lastOrigin);
        }
    };
    ContextMenu.prototype.removeLastOrigin = function () {
        if (this.lastOrigin && this.lastOrigin.id === ORIGIN_ID) {
            this.lastOrigin.remove();
        }
    };
    ContextMenu.ngInjectableDef = i0.defineInjectable({ factory: function ContextMenu_Factory() { return new ContextMenu(i0.inject(i1.Router), i0.inject(i0.NgZone), i0.inject(i0.INJECTOR), i0.inject(i0.ComponentFactoryResolver), i0.inject(i2.Overlay)); }, token: ContextMenu, providedIn: "root" });
    return ContextMenu;
}());
export { ContextMenu };
